<template>
	<div class="container">
		<form @submit="onSubmit" id="ResetPasswordForm" class="change-password">
			<div class="mb-3 text-center">
				<hr />
				<strong>{{ $t("view.club.menus.resetPassword") }}</strong>
				<hr />
			</div>
			<div class="row">
				<div class="col-12">
					<div class="body">
						<div v-if="fcp" class="alert alert-warning">
							کاربر گرامی! کلمه عبور انتخابی شما برای استفاده از
							پنل مشتریان رامنیک ضعیف است ! لطفا کلمه عبور خود را
							تغییر دهید. حداقل طول کلمه عبور جدید باید 8 کاراکتر
							باشد.
						</div>

						<div class="col-12 mb-2">
							<label>کلمه عبور فعلی</label>
							<input
								type="password"
								class="form-control"
								v-model="oldPassword"
								data-label="کلمه عبور فعلی"
								data-validations='["required","password"]'
							/>
						</div>
						<div class="col-12 mb-2">
							<label>کلمه عبور جدید</label>
							<input
								type="password"
								class="form-control"
								v-model="password"
								data-label="کلمه عبور جدید"
								data-validations='["required","password","password2"]'
							/>
						</div>
						<div
							class="alert alert-warning m-0"
							v-if="warnings.length"
						>
							<label></label>
							<ul>
								<li v-for="warning in warnings">
									{{
										$t(warning.type, {
											label: warning.label
										})
									}}
								</li>
							</ul>
						</div>
						<div
							class="alert alert-danger m-0"
							v-if="errors.length"
						>
							<label></label>
							<ul>
								<li v-for="error in errors">
									{{ $t(error.type) }}
								</li>
							</ul>
						</div>
						<div class="alert alert-danger m-0" v-if="isInvalid">
							<label>اطلاعات وارد شده صحیح نیست</label>
						</div>
						<div class="col-12 pr-0 pl-0 mt-2">
							<button
								class="btn btn-dark mt-3 w-100"
								style="height:45px;"
								type="submit"
								v-bind:disabled="loading"
							>
								<span v-if="!loading">تغییر کلمه عبور</span>
								<span
									v-if="loading"
									class="spinner-border spinner-border-sm"
								></span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import store from "@/store";
import utility from "@/plugins/utility";
const form = new utility.form("#ResetPasswordForm");

export default {
	data() {
		return {
			loading: false,
			warnings: [],
			errors: [],
			oldPassword: "",
			password: "",
			isInvalid: false
		};
	},

	computed: {
		fcp() {
			return localStorage.getItem("__fcp");
		}
	},

	methods: {
		onSubmit(evt) {
			evt.preventDefault();
			this.isInvalid = false;
			this.warnings = form.errors();
			this.errors = [];

			if (this.warnings.length == 0) {
				this.request(
					"/api/App/ResetPassword",
					{
						OldPassWord: this.oldPassword,
						PassWord: this.password
					},
					response => {
						if (response.success == true) {
							const db = new utility.db();
							store.user = null;
							store.customer = null;
							store.token = null;
							db.delete("__c");
							db.delete("__t");
							localStorage.removeItem("__fcp");
							this.$router.push("/auth");
						} else {
							this.isInvalid = true;
						}
					}
				);
			}
		},

		request(url, data, succees, method) {
			this.loading = true;
			axios({
				method: method || "post",
				url: url,
				data: data
			})
				.then(response => {
					this.loading = false;
					succees(response.data);
				})
				.catch(error => {
					this.errors = [{ type: "errors.server" }];
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
.change-password .body {
	width: 50%;
	margin: 40px auto;
	padding: 20px;
	background-color: #fff;
	border-radius: 10px;
	border-bottom: #ddd solid 2px;
}

.change-password .body input {
	height: 50px;
	outline: none;
	-webkit-box-shadow: none;
	box-shadow: none;
	background: #f8f8f8;
	border: none;
}

@media screen and (max-width: 768px) {
	.change-password .body {
		width: 100%;
	}
}
</style>
